@if (!embedded()) {
  <ion-header>
    <ion-toolbar>
      <ion-buttons slot="start">
        <ion-back-button
          mode="md"
          defaultHref="settings"
        ></ion-back-button>
      </ion-buttons>
      <ion-title
        role="heading"
        aria-level="1"
        mode="md"
      >
        {{ 'page.settings.permissions' | translate }}
      </ion-title>
    </ion-toolbar>
  </ion-header>
  <ion-content class="ion-padding">
    <div class="app__content">
      <div class="app__description">
        <p>{{ 'page.settings.permissions.desc' | translate }}</p>
      </div>
      <ng-container *ngTemplateOutlet="content"></ng-container>
    </div>
  </ion-content>
} @else {
  <ng-container *ngTemplateOutlet="content"></ng-container>
}

<ng-template #content>
  <ng-container [formGroup]="permissionsForm">
    <app-settings-control
      [type]="'location'"
      [control]="locationControl"
    ></app-settings-control>
  </ng-container>
</ng-template>
